import { formatCreditCount } from "@shared/subscription-presentation";
import { useUsageBalance } from "@/hooks/use-usage";

export function OutOfCreditsModal({
  balance,
  needed,
  onClose,
  onUpgrade,
}: {
  balance: number;
  needed: number;
  onClose: () => void;
  onUpgrade: () => void;
}) {
  // Trial users get trial-specific copy — "credits reset on your next
  // renewal" is wrong for them (trial credits never renew; upgrading is
  // the only way forward).
  const usage = useUsageBalance();
  const isPromo = usage.data?.plan?.isPromo === true;
  const isTrial = !isPromo && usage.data?.plan?.status === "trialing";
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
      data-testid="out-of-credits-modal"
    >
      <div
        className="max-w-md rounded bg-white p-6 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-lg font-semibold">
          {isPromo ? "Promotional credits used up" : isTrial ? "Free trial credits used up" : "Out of credits"}
        </h2>
        <p className="mt-2 text-sm text-neutral-600">
          {isPromo
            ? `This action needs ${formatCreditCount(needed)} credits. You have ${formatCreditCount(balance)} promotional credits remaining. Upgrade to keep creating.`
            : isTrial
            ? "You've used all your free trial credits. Upgrade now to keep creating — your plan starts right away with a full month of credits."
            : `This action needs ${formatCreditCount(needed)} credits. You have ${formatCreditCount(balance)} remaining. Upgrade to keep working — credits reset on your next renewal.`}
        </p>
        <div className="mt-4 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="rounded border border-neutral-300 bg-white px-3 py-1.5 text-sm hover:bg-neutral-50"
            data-testid="out-of-credits-cancel"
          >
            Cancel
          </button>
          <button
            onClick={onUpgrade}
            className="rounded bg-black px-3 py-1.5 text-sm text-white hover:bg-neutral-800"
            data-testid="out-of-credits-upgrade"
          >
            Upgrade
          </button>
        </div>
      </div>
    </div>
  );
}
